"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var i=require("react"),g=require("@vfuk/core-base-props"),x=require("@vfuk/core-themes"),t=require("styled-components");function d(e){return e&&e.__esModule?e:{default:e}}var l=d(i),j=d(t);const k=e=>({appearance:{primary:{background:e.color.opacity5.default}}}),u=t.createGlobalStyle(e=>t.css`
    ${e.show&&e.overflowHidden&&t.css`
      html,
      body {
        overflow: hidden;
      }
    `}
  `),p=j.default.div(e=>{const{background:r}=e.overlayTheme.appearance[e.appearance];return t.css`
    background: ${r};
    position: ${e.position};
    z-index: ${e.zIndex};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    ${e.blur&&`
    backdrop-filter: blur(5px);
  `}
  `});var H=Object.freeze({__proto__:null,HideOverflow:u,Overlay:p}),P=Object.defineProperty,n=Object.getOwnPropertySymbols,T=Object.prototype.hasOwnProperty,$=Object.prototype.propertyIsEnumerable,c=(e,r,a)=>r in e?P(e,r,{enumerable:!0,configurable:!0,writable:!0,value:a}):e[r]=a,z=(e,r)=>{for(var a in r||(r={}))T.call(r,a)&&c(e,a,r[a]);if(n)for(var a of n(r))$.call(r,a)&&c(e,a,r[a]);return e};const s=({position:e="fixed",show:r=!1,overflowHidden:a=!1,zIndex:v=10,blur:f=!1,onClick:b,appearance:y="primary",localTheme:m,id:O,dataSelectorPrefix:_,dataAttributes:h})=>{const o="Overlay",w=x.useLocalTheme(o,k,m);return r?l.default.createElement(i.Fragment,null,l.default.createElement(u,{show:r,overflowHidden:a}),l.default.createElement(p,z({onClick:b,position:e,zIndex:v,blur:f,appearance:y,overlayTheme:w,id:O,"data-selector":g.getDataSelector(_),"data-component-name":o},h))):null};exports.Overlay=s;exports.OverlayStyles=H;exports.default=s;
//# sourceMappingURL=index.cjs.map
